import { Route } from 'react-router-dom';
import BeforeEachRoute from './beforeEach';

const AppRoute = ({ 
	component: Component, 
	layout: Layout, 
	isAuthProtected, 
	type: Type,
	routeModules,
    routeFeatures,
    ignoreModuleLoadingComponent,
	...rest 
}) => {
	return <Route
		{ ...rest }
		render={(props) => (
			<BeforeEachRoute 
				layout={ Layout } 
				isAuthProtected={ isAuthProtected } 
				component={ Component } 
				componentProps={ props } 
				type={ Type }
				routeModules={ routeModules }
                routeFeatures={ routeFeatures }
                ignoreModuleLoadingComponent={ignoreModuleLoadingComponent}
			/>
		)}
	/>
};

export default AppRoute;